export default function HubHeader() {
  const hubheaderBg = document.querySelector(".hub-header-bg");

  if (!hubheaderBg) return;

  const backgroundUrl = hubheaderBg.dataset.background;
  hubheaderBg.style.setProperty('background-image', `url(${backgroundUrl})`);
}
